<section class="extra_padding_for_header">
<!-- error section -->
<div class="d-flex flex-column align-items-center justify-content-center pt-3 px-4 pt-md-3 mt-md-4">
    <div class="alert alert-danger text-left text-md-center " role="alert">
        {{ errorMsg }}
    </div>
</div>

<!-- body section -->
<div class="d-flex flex-column align-items-center justify-content-center m-md-5 m-3">
    <svg class="mb-4" xmlns="http://www.w3.org/2000/svg" width="131" height="113" viewBox="0 0 131 113" fill="none">
        <path
            d="M64.9904 8.19812C65.1305 8.12025 65.3057 8.07143 65.4999 8.07143C65.6941 8.07143 65.8693 8.12025 66.0094 8.19812C66.1304 8.26538 66.2904 8.3883 66.4511 8.66164L121.796 102.828C122.084 103.318 122.079 103.831 121.814 104.308C121.681 104.548 121.515 104.705 121.372 104.794C121.253 104.868 121.1 104.929 120.845 104.929H10.1545C9.89979 104.929 9.74651 104.868 9.62767 104.794C9.48488 104.705 9.31883 104.548 9.18607 104.308C8.92128 103.831 8.91549 103.318 9.20333 102.828L64.5487 8.66164C64.7094 8.3883 64.8694 8.26538 64.9904 8.19812ZM73.4096 4.57183C69.8269 -1.52394 61.1729 -1.52394 57.5902 4.57183L2.24478 98.7385C-1.44413 105.015 2.98455 113 10.1545 113H120.845C128.015 113 132.444 105.015 128.755 98.7385L73.4096 4.57183Z"
            fill="#E59A2C" />
        <path
            d="M57.4292 88.7852C57.4292 84.3274 61.0429 80.7137 65.5006 80.7137C69.9584 80.7137 73.5721 84.3274 73.5721 88.7852C73.5721 93.2429 69.9584 96.8566 65.5006 96.8566C61.0429 96.8566 57.4292 93.2429 57.4292 88.7852Z"
            fill="#222223" />
        <path
            d="M58.2199 40.3165C57.7899 36.0165 61.1667 32.2852 65.4882 32.2852C69.8097 32.2852 73.1865 36.0164 72.7565 40.3165L69.9255 68.6266C69.6975 70.9063 67.7792 72.6423 65.4882 72.6423C63.1972 72.6423 61.2789 70.9063 61.0509 68.6266L58.2199 40.3165Z"
            fill="#222223" />
    </svg>
    <div class="heading mb-4">
        Oops! We couldn’t find your credit report
    </div>
    <div class="sub-headingA mb-2">
        Your credit report info couldn’t be found in our system, so you will notice some missing information.
    </div>

    <div class="sub-headingB mb-2">We don’t want you to miss out – contact a JustMoney coach, who will help you get set up.
    </div>
    <a href="tel:0875376113" class="callus">
        087 537 6113</a>
    <a id="btn_userJourney_noCreditScore_registration" href="/portal/dashboard" class="next-button">
        Go to Dashboard
    </a>
</div>

<app-post-register-footer></app-post-register-footer>
</section>